import { render } from "./RoadmapInitiativesModal.vue?vue&type=template&id=e88d09b8"
import script from "./RoadmapInitiativesModal.vue?vue&type=script&lang=js"
export * from "./RoadmapInitiativesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__